<template>
  <b-modal
    id="modal-reserve-contract"
    ref="modal-reserve-contract"
    title="Đánh dấu bảo lưu CKS & HDDT"
    size="md"
    hide-footer
    @show="resetForm"
  >
    <div class="form-group">
      <label class="form-label required">Trạng thái bảo lưu HĐ & CKS</label>
      <b-form-select
        v-model="form.reserveStatus"
        :options="reserveStatusOptions"
        class="form-control"
        required
      />
    </div>

    <div v-if="form.reserveStatus === 'RESERVED'" class="form-group">
      <label class="form-label required">Ngày bắt đầu bảo lưu</label>
      <b-form-input v-model="form.reserveDate" type="date" class="form-control" required />
    </div>

    <div class="form-group">
      <label class="form-label">Ghi chú</label>
      <b-form-textarea
        v-model="form.note"
        class="form-control"
        rows="3"
        placeholder="Nhập ghi chú..."
      />
    </div>

    <div class="d-flex justify-content-end">
      <b-button variant="secondary" class="mr-2" @click="$bvModal.hide('modal-reserve-contract')">
        Hủy
      </b-button>
      <b-button variant="primary" :disabled="!isFormValid" @click="handleSubmit">
        Xác nhận
      </b-button>
    </div>
  </b-modal>
</template>

<script>
  import { ContractService } from '@/services/contract.service'
  import Config from '@/thirdParty/config'

  export default {
    name: 'ReserveContractModal',
    props: {
      contractId: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        form: {
          reserveStatus: '',
          reserveDate: '',
          note: '',
        },
        reserveStatusOptions: [
          { value: '', text: 'Chọn trạng thái', disabled: true },
          ...(Config?.reserveStatusOptions?.map(item => ({ value: item.id, text: item.text })) ||
            []),
        ],
      }
    },
    computed: {
      isFormValid() {
        if (!this.form.reserveStatus) return false
        if (this.form.reserveStatus === 'RESERVED' && !this.form.reserveDate) return false
        return true
      },
    },
    methods: {
      resetForm() {
        this.form = {
          reserveStatus: '',
          reserveDate: '',
          note: '',
        }
      },
      show() {
        this.$bvModal.show('modal-reserve-contract')
      },
      async handleSubmit() {
        try {
          this.$emit('loading', true)

          const params = {
            id: this.contractId,
            reserveStatus: this.form.reserveStatus,
            note: this.form.note,
          }

          if (this.form.reserveStatus === 'RESERVED' && this.form.reserveDate) {
            params.reserveTime = new Date(this.form.reserveDate).getTime()
          }

          const response = await ContractService.reserveContract(params)

          if (response.code === 1000) {
            this.$emit('success', response.message || 'Cập nhật trạng thái bảo lưu thành công')
            this.$bvModal.hide('modal-reserve-contract')
            this.$emit('refresh')
          } else {
            this.$emit('error', response.message || response.error)
          }
        } catch (error) {
          this.$emit('error', error.message || 'Có lỗi xảy ra')
        } finally {
          this.$emit('loading', false)
        }
      },
    },
  }
</script>

<style scoped>
  .required::after {
    content: ' *';
    color: red;
  }

  .form-label {
    font-weight: 500;
    margin-bottom: 5px;
  }

  .form-group {
    margin-bottom: 15px;
  }
</style>
